import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppMainComponent } from './app.main.component';

import {UsersComponent} from './users/users.component';
import {UserListComponent} from './users/users.component';
import {UserComponent} from './users/users.component';
import {ProfileComponent} from './users/profile/profile.component';
import {UsageComponent} from './usage/usage.component';

import {RolesComponent, RoleListComponent, RoleComponent} from './roles/roles.component';
import {FormsComponent, FormListComponent, FormComponent} from './forms/form.component';

import {UsersAdminComponent} from './admin/users/users.component';
import {UserAdminListComponent} from './admin/users/users.component';
import {UserAdminComponent} from './admin/users/users.component';

import {PartnersComponent} from './admin/partners/partners.component';
import {PartnerListComponent} from './admin/partners/partners.component';
import {PartnerComponent} from './admin/partners/partners.component';

import {PartnerGroupsComponent, PartnerGroupListComponent, PartnerGroupComponent} from './admin/partner-groups/partner-groups.component';
import {ProcessSComponent,ProcessListComponent,ProcessComponent} from './admin/process/process.component';
import {ConfigAdminComponent} from './admin/config/config.component';

import { AppLoginComponent } from './login/app.login.component';
import {DashBoardComponent} from './dashboard/dashboard.component';

import { LoginInGuardService, LoginInSAService } from './users/login-in-guard.service';
import { HelpComponent } from './help/help.component';


@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '', component: AppMainComponent,
                children: [
                    { path: '', pathMatch: "full", redirectTo: "/dashboard" },
                    { path: 'dashboard', component: DashBoardComponent, canActivate: [LoginInGuardService] },
                    { path: 'profile', component: ProfileComponent, canActivate: [LoginInGuardService] },
                    { path: 'usage', component: UsageComponent, canActivate: [LoginInGuardService] },
                    {
                        path: 'admin', canActivate: [LoginInGuardService],
                        children: [
                            {
                                path: 'users', component: UsersComponent,
                                children: [
                                    { path: '', component: UserListComponent },
                                    { path: 'new', component: UserComponent },
                                    { path: 'user/:id', component: UserComponent }
                                ], canActivate: [LoginInGuardService], runGuardsAndResolvers: 'always'
                            },
                            {
                                path: 'roles', component: RolesComponent,
                                children: [
                                    { path: '', component: RoleListComponent },
                                    { path: 'new', component: RoleComponent },
                                    { path: 'role/:id', component: RoleComponent }
                                ], canActivate: [LoginInGuardService], runGuardsAndResolvers: 'always'
                            },
                            {
                                path: 'forms', component: FormsComponent,
                                children: [
                                    { path: '', component: FormListComponent },
                                    { path: 'form/:id', component: FormComponent }
                                ], canActivate: [LoginInSAService], runGuardsAndResolvers: 'always'
                            }
                        ]
                    },
                    {
                        path: 'backendadmin',
                        children: [
                            { 
                                path: '', pathMatch: "full", redirectTo: "/users" },
                                {path: 'users', component: UsersAdminComponent,
                                    children: [
                                        { path: '',  component: UserAdminListComponent },
                                        { path: 'new', component: UserAdminComponent },
                                        { path: 'user/:id', component: UserAdminComponent }
                                    ],canActivate: [LoginInGuardService],runGuardsAndResolvers: 'always'
                                },
                        {path: 'partners', component: PartnersComponent,
                            children: [
                                { path: '', component: PartnerListComponent },
                                { path: 'new', component: PartnerComponent },
                                { path: 'partner/:id', component: PartnerComponent }
                                ],canActivate: [LoginInGuardService],runGuardsAndResolvers: 'always'
                            },
                        {path: 'partner-groups', component: PartnerGroupsComponent,
                            children: [
                                { path: '', component: PartnerGroupListComponent },
                                { path: 'new', component: PartnerGroupComponent },
                                { path: 'partner-group/:id', component: PartnerGroupComponent }
                            ],canActivate: [LoginInGuardService],runGuardsAndResolvers: 'always'
                         },
                        {path: 'processs', component: ProcessSComponent,
                            children: [
                                { path: '', component: ProcessListComponent },
                                { path: 'process/:id', component: ProcessComponent }
                            ],canActivate: [LoginInSAService],runGuardsAndResolvers: 'always'},
                        {path: 'config', component: ConfigAdminComponent,canActivate: [LoginInSAService],runGuardsAndResolvers: 'always'}

                    ]
                    },
                    { path: 'help', component: HelpComponent }
                ]
            },
            { path: 'login', component: AppLoginComponent }
        ], { scrollPositionRestoration: 'enabled' })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
